import React from 'react';
import { Alert } from 'react-bootstrap';
const Message = ({ variant, children }) => {
  return <Alert variant={variant} style={{width:'100%', padding:'10px 0px',textAlign: 'center'}}>{children}</Alert>
};

Message.defaultProps = {
  variant: 'info',
};

export default Message;
